import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { DashboardService } from '../dashboard.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as Highcharts from 'highcharts';
import HighchartsExporting from 'highcharts/modules/exporting'
import HighchartsExportData from 'highcharts/modules/export-data';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DatePipe } from '@angular/common';


HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);
@Component({
  selector: 'app-sensor-data',
  templateUrl: './sensor-data.component.html',
  styleUrls: ['./sensor-data.component.scss']
})
export class SensorDataComponent implements OnInit {
  private ResponseSensorData: Subject<any> = new Subject();
  public sensorform: FormGroup;
  Highcharts = Highcharts;
  public updateFlag: boolean = false;
  public login_Id = localStorage.login_id;
  pipe = new DatePipe('en-US')
  sensorData: any = {};
  SensorData: any = [];
  categories: any = [];
  data: any;
  sensorgraph: any = {};
  addComponentRef(chart: any) {
    chart.parentComponent = this
  }
  chartOptions = {
    chart: {
      type: "spline"
    },

    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: ''
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  constructor(private toastr: ToastrService, private fb: FormBuilder, private router: Router, private dashboardService: DashboardService) { }

  ngOnInit() {
    Highcharts.setOptions({
      lang: {
        decimalPoint: '.',
        thousandsSep: ''
      }
    });
    this.sensorform = this.fb.group({
      sensor_id: ["", Validators.required],
      from_date: ["", Validators.required],
      to_date: ["", Validators.required],
    });
    this.sensorform.get('from_date').setValue(new Date());
    this.sensorform.get('to_date').setValue(new Date());
    this.SensorPageData();
  }
  onChangeSensorList(value) {

  }
  // get inverter list on drop Down for Normal User
  public SensorPageData() {
    this.sensorData = {
      user_id: this.login_Id
    }
    this.dashboardService.sensorDataPage(this.sensorData)
      .pipe(takeUntil(this.ResponseSensorData))
      .subscribe(
        async result => {
          this.categories = [];
          this.data = [];
          if (result.status) {
            this.SensorData = result.resultObject;
            if (this.SensorData.sensorData[0].pname) {
              this.sensorform.get('sensor_id').setValue(this.SensorData.sensorData[0].pname);
            }
            var sensorgraphData = this.SensorData.graphData;
            for (let i = 0; i < sensorgraphData.length; i++) {
              if (sensorgraphData[i].date_time) {
                // let stringToSplit = sensorgraphData[i].date_time;
                // let x = stringToSplit.split(" ");                
                // this.categories.push(x[1]); 
                this.categories.push(sensorgraphData[i].date_time);                
                this.data.push(Number(sensorgraphData[i].value));
              }
            }
            if (this.SensorData.sensorData[0].pname == 'Ambient Temperature') {
              var seriseName = this.SensorData.sensorData[0].pname + " (Degree C)";
            } else if (this.SensorData.sensorData[0].pname == 'Humidity') {
              seriseName = this.SensorData.sensorData[0].pname + " (%)";
            } else if (this.SensorData.sensorData[0].pname == 'Irradiation') {
              // seriseName = this.SensorData.sensorData[0].pname + " (W/m^2)";
              seriseName = "Irradiance (W/m^2)";
            } else if (this.SensorData.sensorData[0].pname == 'Module Temperature') {
              seriseName = this.SensorData.sensorData[0].pname + " (Degree C)";
            } else if (this.SensorData.sensorData[0].pname == 'Wind Speed') {
              seriseName = this.SensorData.sensorData[0].pname + " (Km/hr)";
            }else if (this.SensorData.sensorData[0].pname == 'Wind Direction') {
              seriseName = this.SensorData.sensorData[0].pname + " (Degree C)";
            }
            this.chartOptions.series = [{
              name: seriseName,
              data: this.data
            },];
            this.SensorGraph();
            this.chartOptions.xAxis = [{
              categories: this.categories
            },];
            this.updateFlag = true;
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // show sensor graph
  public SensorGraph() {
    this.sensorgraph = {
      user_id: this.login_Id,
      pname: this.sensorform.controls['sensor_id'].value,
      fromDate: this.pipe.transform(this.sensorform.controls['from_date'].value, "dd-MM-yyyy"),
      toDate: this.pipe.transform(this.sensorform.controls['to_date'].value, "dd-MM-yyyy"),
    }
      this.dashboardService.singalSensorData(this.sensorgraph)
      .pipe(takeUntil(this.ResponseSensorData))
      .subscribe(
        async result => {
          this.categories = [];
          this.data = [];
          if (result.status) {
            var sensorgraphData = result.resultObject;
            for (let i = 0; i < sensorgraphData.length; i++) {
              if (sensorgraphData[i].date_time) {
                // let stringToSplit = sensorgraphData[i].date_time;
                // let x = stringToSplit.split(" ");
                // this.categories.push(x[0]);
                this.categories.push(sensorgraphData[i].date_time);    
                this.data.push(Number(sensorgraphData[i].value));
              }
            }
            if (this.sensorform.controls['sensor_id'].value == 'Ambient Temperature') {
              var seriseName = this.sensorform.controls['sensor_id'].value + " (Degree C)";
            } else if (this.sensorform.controls['sensor_id'].value == 'Humidity') {
              seriseName = this.sensorform.controls['sensor_id'].value + " (%)";
            } else if (this.sensorform.controls['sensor_id'].value == 'Irradiation') {
              seriseName = "Irradiance (W/m^2)";
            } else if (this.sensorform.controls['sensor_id'].value == 'Module Temperature') {
              seriseName = this.sensorform.controls['sensor_id'].value + " (Degree C)";
            } else if (this.sensorform.controls['sensor_id'].value == 'Wind Speed') {
              seriseName = this.sensorform.controls['sensor_id'].value + " (Km/hr)";
            }else if (this.sensorform.controls['sensor_id'].value  == 'Wind Direction') {
              seriseName = this.sensorform.controls['sensor_id'].value + " (Degree C)";
            }
            this.chartOptions.series = [{
              name: seriseName,
              data: this.data
            },];

            this.chartOptions.xAxis = [{
              categories: this.categories
            },];
            this.updateFlag = true;

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  ngOnDestroy() {
    // this.uploadFlagSpinner = false;

    this.ResponseSensorData.next();
    this.ResponseSensorData.complete();
  }
}
